import { actionCreator } from 'rxbeach';
import { ForgotBody, LoginBody, RegisterBody, ResetBody } from '../apiService';
import { User } from '../types';

export const login = actionCreator<LoginBody>('[auth] login');
export const register = actionCreator<RegisterBody>('[auth] register');
export const logout = actionCreator('[auth] logout');
export const forgot = actionCreator<ForgotBody>('[auth] forgot');
export const reset = actionCreator<ResetBody>('[auth] reset');
export const authenticate = actionCreator('[auth] authenticate');
export const authSuccess =
  actionCreator<{ user: User; token?: string }>('[auth] success');
export const authError = actionCreator<any>('[auth] error');
